<template>
  <div>
    <mu-card id="lessonRatingStart" v-if="mode === 'start' && (!course.taken.start_questions && !ratingStart.saved)">
      <div class="start-q" v-for="q, index in course.start_questions" :key="'start-rating-' + index"
           v-show="ratingStart.activeIndex === index">


        <mu-card-title :title="q.question" :subTitle="index+1 + '/' + course.start_questions.length"
                       titleClass="largeTitle"/>
        <mu-card-text>
          <!--<h5 class="largeTitle blueTitle">
            <span v-text="q.question"></span>
            <span class="index" v-text="index+1 + '/' + course.start_questions.length" v-if="course.start_questions.length > 1"></span>
          </h5>-->
          <mu-flexbox class="ratings" align="flex-start">
            <mu-flexbox-item class="rating" v-for="rating, ratingIndex in ratingStart.ratings"
                             :key="'start-rating-label-' + ratingIndex"
                             @click.native="addScoreToMarkers(q.question_id, ratingIndex+1)">
              <span class="amount" v-text="ratingIndex+1"></span>
              <span class="label" v-text="rating.label" v-if="q.type === 'motivation-text'"></span>
            </mu-flexbox-item>
          </mu-flexbox>

        </mu-card-text>
      </div>
    </mu-card>
    <mu-card id="lessonRatingEnd" v-if="mode === 'end' && (!course.taken.end_questions && !ratingEnd.saved)">
      <mu-card-header titleClass="blueTitle largeTitle" :title="course.end_question" v-once></mu-card-header>
      <mu-card-text>
        <mu-flexbox class="stars" align="flex-start">
          <mu-flexbox-item class="star" v-for="(rating, index) in ratingEnd.ratings"
                           @click.native="saveRatingEnd(index+1)" :key="'end-rating-' + index">
            <mu-icon class="icon" value="star"/>
            <span class="label" v-if="index == 0">{{$t('message.lessonRatingVery')}}</span>
            <span class="label" v-if="index == (ratingEnd.ratings - 1)">{{$t('message.lessonRatingNotVery')}}</span>
          </mu-flexbox-item>
        </mu-flexbox>
      </mu-card-text>
    </mu-card>
  </div>
</template>

<script>
  import LessonApi from './../../../api/Lessons'
  
  export default {
    name: "lesson-rating-panel",
    props: {
      course: {
        type: Object,
        required: true,
      },
      mode: {
        type: String,
        required: true,
      }
    },
    data () {
      return {
        ratingStart: {
          ratings: [
            {label: 'Very'},
            {label: 'Somewhat'},
            {label: 'It made no difference'},
            {label: 'Not particularly'},
            {label: 'I didn\'t do this one'},
          ],
          saved: false,
          activeIndex: 0,
          scores: [],
        },
        ratingEnd: {
          ratings: 5,
          saved: false,
        }
      }
    },
    methods: {
      addScoreToMarkers (question_id, rating) {
        let self = this;
        // push scores
        self.ratingStart.scores.push({
          question_id: question_id,
          rating: rating
        });
        if (self.ratingStart.scores.length === self.course.start_questions.length) {
          // save scores
          self.saveRatingStart();
        } else {
          // increment question
          self.ratingStart.activeIndex += 1;
        }
      },
      saveRatingStart() {
        let self = this;
        LessonApi.saveLessonStartRating({
          ratings: self.ratingStart.scores,
        }).then((response) => {
          self.ratingStart.saved = true;
        }).catch((error) => {
        });
      },
      saveRatingEnd(rating) {
        let self = this;
        let r = self.ratingEnd.ratings - rating + 1;

        LessonApi.saveLessonEndRating({
          course_id: self.course.course_id,
          rating: r
        }).then((response) => {
          if (response.data.complete) {
            self.ratingEnd.saved = true;
          }
        }).catch((error) => {
          alert('Failed');
        });
      }
    },
    mounted () {
      let self = this;
    }
  }

</script>

<style lang="less" scoped>

  #lessonRatingStart {
    .ratings {
      margin: 0 0 15px;
    }
    .rating {
      font-size: 15px;
      text-align: center;
      cursor: pointer;
      -webkit-transition: background, border 0.2s linear;
      -moz-transition: background, border 0.2s linear;
      -ms-transition: background, border 0.2s linear;
      -o-transition: background, border 0.2s linear;
      transition: background, border 0.2s linear;
      .amount {
        display: inline-block;
        width: 103px;
        line-height: 85px;
        font-size: 50px;
        font-weight: 600;
        color: #FFF;
        border-radius: 100%;
        border: 9px solid;
        background-color: #7CBE30;
        -webkit-transition: background, border 0.2s linear;
        -moz-transition: background, border 0.2s linear;
        -ms-transition: background, border 0.2s linear;
        -o-transition: background, border 0.2s linear;
        transition: background, border 0.2s linear;
      }
      &:hover {
        .amount {
          border-style: double;
          -webkit-transition: background, border 0.2s linear;
          -moz-transition: background, border 0.2s linear;
          -ms-transition: background, border 0.2s linear;
          -o-transition: background, border 0.2s linear;
          transition: background, border 0.2s linear;
        }
      }
      &:nth-child(2) .amount {
        background-color: #BFCE45;
      }

      &:nth-child(3) .amount {
        background-color: #F5A623;
      }

      &:nth-child(4) .amount {
        background-color: #FA7D33;
      }

      &:nth-child(5) .amount {
        background-color: #F52A00;
      }
      .label {
        display: block;
        margin: 20px 0 0;
        color: #5C5B5C;
        font-weight: 600;
      }
    }
  }

  @media only screen and (max-width: 650px) {
    #lessonRatingStart {
      .rating {
        .amount {
          width: auto;
          line-height: normal;
          padding:  8px 16px;
          font-size: 24px;
          border-width: 1px;
        }
        .label {
          display: none;
        }
      }
    }
  }

  #lessonRatingEnd {
    margin: 24px 0 0;
    color: #5B5A5C;
    h2 {
      margin: 0 0 1em;
    }
    .stars {
      direction: rtl;
      text-align: left;
    }
    .star {
      color: #9C9C9C;
      text-align: center;
      cursor: pointer;
      -webkit-transition: margin 100ms linear;
      -moz-transition: margin 100ms linear;
      -ms-transition: margin 100ms linear;
      -o-transition: margin 100ms linear;
      transition: margin 100ms linear;
      .mu-icon {
        font-size: 65px;
        color: #E3E3E3;
        -webkit-transition: margin 100ms linear;
        -moz-transition: margin 100ms linear;
        -ms-transition: margin 100ms linear;
        -o-transition: margin 100ms linear;
        transition: margin 100ms linear;
      }
      .label {
        display: block;
        margin: 9px 0 0;
        font-size: 15px;
      }
      &:hover {
        .mu-icon,
        ~ .star .mu-icon {
          color: #F5A623;
          -webkit-transition: margin 100ms linear;
          -moz-transition: margin 100ms linear;
          -ms-transition: margin 100ms linear;
          -o-transition: margin 100ms linear;
          transition: margin 100ms linear;
        }
      }
    }
  }
</style>




// WEBPACK FOOTER //
// RatingPanel.vue?a5aa4256